var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Observable from "./Observable";
function statusEquals(status1, status2) {
    return status1 === status2 || JSON.stringify(status1) === JSON.stringify(status2);
}
var endsWith = function (str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
};
var Authentication = /** @class */ (function () {
    function Authentication(configuration) {
        var _this = this;
        this.tokens = {};
        this.loggedOutStatus = {
            loggedIn: false,
            isGuest: false,
            isAdmin: false,
            isRegistered: false,
            impersonating: false,
            userInfo: null,
            rememberMe: false,
        };
        this.pendingOperations = 0;
        this.post = function (url, data) {
            _this.pendingOperations += 1;
            return fetch(_this.config.baseUrl + url, {
                method: "POST",
                body: data,
                //credentials: "include",
            }).then(function (ret) {
                if (ret.status === 200) {
                    return ret.json().then(function (data) {
                        _this.pendingOperations -= 1;
                        return data;
                    }, function (err) {
                        _this.pendingOperations -= 1;
                        return Promise.reject(err);
                    });
                }
                else {
                    _this.pendingOperations -= 1;
                    return Promise.reject(ret.status + ": " + ret.statusText);
                }
            }, function (err) {
                _this.pendingOperations -= 1;
                return Promise.reject(err);
            });
        };
        this.GetPendingOperations = function () {
            return _this.pendingOperations;
        };
        this.Dispose = function () {
            window.removeEventListener("storage", _this.onStorageEvent);
        };
        this.Status = new Observable();
        this.GetStatus = function () {
            return __assign({}, _this.status);
        };
        this.GetAccessToken = function () {
            return (_this.status.loggedIn ? _this.tokens.accessToken : null) || null;
        };
        this.pushStatus = function () {
            if (statusEquals(_this.status, _this.lastStatus))
                return;
            _this.lastStatus = _this.status;
            var status = __assign({}, _this.status);
            _this.Status.notify(status);
        };
        this.Login = function (email, password, rememberMe) {
            //upon failure, returns a failure, and does not log out
            return _this.loginWithUsername(email, password, rememberMe);
        };
        this.Logout = function () {
            //always returns success
            if (!_this.status.loggedIn)
                return Promise.resolve();
            _this.status = {
                impersonating: false,
                isGuest: false,
                isAdmin: false,
                isRegistered: false,
                loggedIn: false,
                rememberMe: false,
                userInfo: null,
            };
            _this.updateSession();
            _this.pushStatus();
            return Promise.resolve();
        };
        this.CheckRegistered = function (email) {
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("email", email);
            return _this.post("checkregistered", postData).then(function (res) { return res.hasValidAccount; }, function (res) {
                console.error("Unable to check if email account was registered", email, res);
                return false;
            });
        };
        this.ChangeEmail = function (newEmail, verifyPassword) {
            //returns an error if not logged on or invalid password
            if (!_this.status.loggedIn || _this.status.isGuest || !_this.tokens.refreshToken)
                return Promise.reject();
            var postData = new FormData();
            postData.append("password", verifyPassword);
            postData.append("refreshToken", _this.tokens.refreshToken);
            postData.append("newEmail", newEmail);
            postData.append("client_id", _this.config.clientId);
            return _this.post("changeemail", postData).then(function (res) {
                _this.processLoginResponse(res, _this.status.rememberMe);
            });
        };
        this.ChangePassword = function (oldPassword, newPassword) {
            //returns an error if not logged on or invalid password
            if (!_this.status.loggedIn || _this.status.isGuest || !_this.tokens.refreshToken)
                return Promise.reject();
            var postData = new FormData();
            postData.append("newPassword", newPassword);
            postData.append("oldPassword", oldPassword);
            postData.append("refreshToken", _this.tokens.refreshToken);
            postData.append("client_id", _this.config.clientId);
            return _this.post("changepassword", postData).then(function (res) {
                _this.processLoginResponse(res, _this.status.rememberMe);
            });
        };
        this.UpgradeGuest = function (name, email, password, rememberMe) {
            //returns an error if not logged on or not guest or invalid password
            if (!_this.status.loggedIn || !_this.status.isGuest || !_this.tokens.refreshToken)
                return Promise.reject();
            var postData = new FormData();
            postData.append("refreshToken", _this.tokens.refreshToken);
            postData.append("name", name);
            postData.append("email", email);
            postData.append("password", password);
            postData.append("client_id", _this.config.clientId);
            return _this.post("upgradeguest", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
            });
        };
        this.UpgradeGuestForOrder = function (clubOrderGuid, password, rememberMe) {
            var postData = new FormData();
            postData.append("clubOrderGuid", clubOrderGuid);
            postData.append("password", password);
            postData.append("client_id", _this.config.clientId);
            return _this.post("upgradeguestfororder", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
            });
        };
        this.ResetPasswordRequest = function (email) {
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("email", email);
            return fetch(_this.config.baseUrl + "resetpasswordrequest", {
                method: "POST",
                body: postData,
                //credentials: "include",
            }).then(function (ret) {
                if (ret.status === 200) {
                    return true;
                }
                else if (ret.status === 400) {
                    return false;
                }
                else {
                    return Promise.reject(ret.status + ": " + ret.statusText);
                }
            });
        };
        this.ResetPassword = function (resetToken, email, newPassword, rememberMe) {
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("resetToken", resetToken);
            postData.append("newPassword", newPassword);
            postData.append("email", email);
            return _this.post("resetpassword", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
            });
        };
        this.Impersonate = function (userId) {
            //returns a failure if not logged in or if failure during impersonation request
            if (!_this.status.loggedIn)
                return Promise.reject();
            if (!_this.tokens.refreshToken || !_this.tokens.refreshTokenExpires)
                return _this.Logout().then(function () {
                    return Promise.reject();
                });
            var postData = new FormData();
            postData.append("refreshToken", _this.tokens.refreshToken);
            postData.append("userId", userId);
            postData.append("client_id", _this.config.clientId);
            return _this.post("impersonate", postData).then(function (res) {
                var now = new Date().getTime();
                _this.tokens.accessToken = res.access_token;
                _this.tokens.accessTokenExpires = res.expires_in * 1000 + now;
                _this.status = {
                    impersonating: true,
                    isGuest: false,
                    isAdmin: res.user_info.roles.filter(function (x) { return x === "Administrators"; }).length > 0,
                    loggedIn: true,
                    isRegistered: true,
                    rememberMe: _this.status.rememberMe,
                    userInfo: {
                        email: res.user_info.email,
                        id: res.user_info.id + "",
                        name: res.user_info.name,
                        roles: res.user_info.roles,
                    },
                };
                _this.updateSession();
                _this.pushStatus();
            });
        };
        this.ImpersonateQuit = function () {
            //attempt to log in as original user, or else just log out
            //always return success
            return _this.refreshToken(true);
        };
        this.EnsureGuest = function (rememberMe) {
            //attempts to create a guest if not logged in
            //fails if createguest fails
            _this.checkSession();
            if (_this.status.loggedIn)
                return Promise.resolve();
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            return _this.post("createguest", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
            });
        };
        this.UpdateToken = function () {
            //inspects session state to see if it's changed
            //refreshes any tokens necessary
            //catches any errors
            //updates status if it has changed
            //returns promise when all that's done
            _this.checkSession();
            if (_this.status.loggedIn && _this.tokens.refreshTokenExpires && _this.tokens.accessTokenExpires) {
                var now = new Date().getTime();
                if (_this.tokens.refreshTokenExpires < now) {
                    return _this.Logout();
                }
                else if (_this.tokens.accessTokenExpires < now) {
                    return _this.refreshToken(false);
                }
                else {
                    return Promise.resolve();
                }
            }
            else {
                return Promise.resolve();
            }
        };
        this.ChangeGuestEmail = function (newEmail) {
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("newEmail", newEmail);
            if (_this.tokens.refreshToken)
                postData.append("refreshToken", _this.tokens.refreshToken);
            return _this.post("changeguestemail", postData).then(function (res) {
                _this.processLoginResponse(res, false);
            });
        };
        this.TryAutoLogin = function () {
            //this does nothing anymore, but it should check if any other tabs are logged in
            _this.checkSession();
            if (_this.status.loggedIn)
                return Promise.resolve();
            //check session cookie to see if the state is in there
            var authCookies = document.cookie
                .split(";")
                .map(function (x) { return x.trim(); })
                .filter(function (x) { return x.substring(0, 15) === "authentication="; })
                .map(function (x) { return x.substring(15); });
            if (authCookies.length > 0) {
                //console.log('Found auth cookie');
                _this.decodeAuthSessionString(decodeURIComponent(authCookies[0]));
                //console.log(`Decoded auth cookie ${this.status.loggedIn}`)
                if (_this.status.loggedIn)
                    return _this.UpdateToken();
            }
            //pull token from localStorage and attempt to log in
            //always return success
            var authDataString = localStorage.getItem("Authentication");
            if (authDataString === null)
                return Promise.resolve();
            //console.log('Found auth localStorage string');
            var tokenData;
            try {
                tokenData = JSON.parse(authDataString);
            }
            catch (_a) {
                return Promise.resolve();
            }
            var now = new Date().getTime();
            if (tokenData &&
                tokenData.version === "1" &&
                tokenData.refreshToken &&
                tokenData.refreshTokenExpires &&
                tokenData.refreshTokenExpires > now) {
                //console.log('Parsed auth localStorage string');
                return _this.loginWithToken(tokenData.refreshToken, true).then(null, function () {
                    //console.log("Removing localStorage string");
                    localStorage.removeItem("Authentication");
                    return;
                });
            }
            return Promise.resolve();
        };
        //This function connects to the auth controller of the same name: SaveCookie(string client_id, string refreshToken)
        this.SaveCookieRedirect = function (redirectTo) {
            if (!_this.status.loggedIn || !_this.tokens.refreshToken)
                return Promise.reject();
            /*
                //send post request to auth controller passing in client id and refesh token (assuming there is a token)
                const postData = new FormData();
                postData.append("client_id", this.config.clientId);
                postData.append("refreshToken", this.tokens.refreshToken);
        
                //return promise of save cookie completing
                return this.axiosAdmin.post<void>('savecookie', postData)
                    .then(
                        res => {
                            //console.log(`savecookie response code ${res.status}`)
                            return;
                        }
                    );
                */
            return _this.UpdateToken().then(function () {
                var token = _this.GetAccessToken();
                if (!token)
                    return Promise.reject();
                window.location.href =
                    _this.config.adminUrl +
                        "/savecookie?client_id=" +
                        encodeURIComponent(_this.config.clientId) +
                        "&accessToken=" +
                        encodeURIComponent(token) +
                        "&redirectTo=" +
                        encodeURIComponent(redirectTo);
                return;
            });
        };
        // ============== private members ==================
        this.refreshTokenPending = null;
        this.refreshToken = function (dontImpersonate) {
            //force a refresh of the tokens
            //always return success
            if (_this.refreshTokenPending != null)
                return _this.refreshTokenPending;
            if (!_this.status.loggedIn)
                return Promise.resolve();
            if (_this.tokens.refreshToken === undefined || _this.tokens.refreshTokenExpires === undefined)
                return _this.Logout();
            if (_this.status.impersonating && !dontImpersonate) {
                _this.refreshTokenPending = _this.Impersonate(_this.status.userInfo.id).then(null, function () {
                    return _this.Logout();
                });
            }
            else {
                _this.refreshTokenPending = _this.loginWithToken(_this.tokens.refreshToken, _this.status.rememberMe).then(null, function () {
                    return _this.Logout();
                });
            }
            _this.refreshTokenPending = _this.refreshTokenPending.then(null, function () {
                return _this.Logout();
            });
            _this.refreshTokenPending = _this.refreshTokenPending.then(function () {
                _this.refreshTokenPending = null;
            }, function () {
                _this.refreshTokenPending = null;
            });
            return _this.refreshTokenPending;
        };
        this.loginWithToken = function (refreshToken, rememberMe) {
            //does not handle error from axios or logout
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("grant_type", "refresh_token");
            postData.append("refresh_token", refreshToken);
            return _this.post("token", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
            });
        };
        this.loginWithUsername = function (username, password, rememberMe) {
            //does not handle error from axios or logout
            var postData = new FormData();
            postData.append("client_id", _this.config.clientId);
            postData.append("grant_type", "password");
            postData.append("username", username);
            postData.append("password", password);
            if (_this.status.loggedIn && _this.status.isGuest && _this.tokens.refreshToken)
                postData.append("guest_refresh_token", _this.tokens.refreshToken);
            return _this.post("token", postData).then(function (res) {
                _this.processLoginResponse(res, rememberMe);
                if (window.PasswordCredential && navigator.credentials && navigator.credentials.store) {
                    var credential = new PasswordCredential({
                        id: username,
                        password: password,
                    });
                    navigator.credentials.store(credential);
                }
            });
        };
        this.processLoginResponse = function (data, rememberMe) {
            var now = new Date().getTime();
            _this.tokens = {
                refreshToken: data.refresh_token,
                refreshTokenExpires: data.refresh_token_exp * 1000 + now,
                accessToken: data.access_token,
                accessTokenExpires: data.expires_in * 1000 + now,
            };
            var isGuest = data.user_info.roles.indexOf("Guests") >= 0;
            //console.log("GUEST: " + isGuest)
            if (isGuest) {
                _this.status = {
                    impersonating: false,
                    isGuest: true,
                    isAdmin: false,
                    loggedIn: true,
                    isRegistered: false,
                    rememberMe: rememberMe,
                    userInfo: {
                        email: data.user_info.email,
                        id: data.user_info.id + "",
                        roles: data.user_info.roles,
                        name: data.user_info.name,
                    },
                };
            }
            else {
                _this.status = {
                    impersonating: false,
                    isGuest: false,
                    isAdmin: data.user_info.roles.filter(function (x) { return x === "Administrators"; }).length > 0,
                    loggedIn: true,
                    isRegistered: true,
                    rememberMe: rememberMe,
                    userInfo: {
                        email: data.user_info.email,
                        id: data.user_info.id + "",
                        roles: data.user_info.roles,
                        name: data.user_info.name,
                    },
                };
            }
            _this.updateSession();
            _this.pushStatus();
        };
        this.onStorageEvent = function (ev) {
            //console.log('Received auth keys from another tab');
            if (ev.key === "AuthenticationSession" && ev.newValue)
                _this.decodeAuthSessionString(ev.newValue);
        };
        this.checkSession = function () {
            //this function is to check other tabs to see if they are logged in (if tokens/status is different)
            //since there's no practical way to do this, this function is a noop
        };
        this.decodeAuthSessionString = function (authDataString) {
            if (authDataString === null)
                return;
            var authData;
            try {
                authData = JSON.parse(authDataString);
            }
            catch (_a) {
                return;
            }
            var now = new Date().getTime();
            if (authData &&
                authData.version === "1" &&
                authData.status &&
                authData.tokens &&
                authData.tokens.refreshToken &&
                authData.tokens.refreshTokenExpires &&
                authData.tokens.refreshTokenExpires > now) {
                _this.tokens = authData.tokens;
                if (!statusEquals(authData.status, _this.status)) {
                    _this.status = authData.status;
                    _this.pushStatus();
                }
            }
        };
        this.updateSession = function () {
            //create a string containing tokens and status to pass between tabs
            var authString = JSON.stringify({
                status: _this.status,
                tokens: _this.tokens,
                version: "1",
            });
            //set and remove from localstorage to trigger a storage event (pass data between active tabs)
            localStorage.setItem("AuthenticationSession", authString);
            localStorage.removeItem("AuthenticationSession");
            //note that sessionStorage is local only to the individual tab, and cookies only update upon refresh
            //cannot put dummy path in path for cookie or else the cookie won't save
            //store in a session cookie in case tab is refreshed or new tab is opened
            document.cookie = "authentication=" + encodeURIComponent(authString) + ";samesite=strict;path=/"; //;path=/dummyauthpath
            //console.log(`Saving authentication cookie: ${this.status.loggedIn} ${this.status.isGuest} ${this.status.rememberMe}`);
            if (_this.status.loggedIn && _this.status.rememberMe && _this.tokens.refreshToken && _this.tokens.refreshTokenExpires) {
                //console.log(`Saving authentication localStorage: ${this.status.loggedIn} ${this.status.isGuest} ${this.status.rememberMe}`);
                localStorage.setItem("Authentication", JSON.stringify({
                    version: "1",
                    refreshToken: _this.tokens.refreshToken,
                    refreshTokenExpires: _this.tokens.refreshTokenExpires,
                }));
            }
            else {
                //console.log('Clear authentication localStorage');
                localStorage.removeItem("Authentication");
            }
        };
        this.config = configuration;
        if (!endsWith(this.config.adminUrl, "/"))
            this.config.adminUrl += "/";
        if (!endsWith(this.config.baseUrl, "/"))
            this.config.baseUrl += "/";
        this.status = this.loggedOutStatus;
        this.lastStatus = this.loggedOutStatus;
        window.addEventListener("storage", this.onStorageEvent);
    }
    return Authentication;
}());
export default Authentication;
